import basicAuthService from './basicAuthService.js';

export default basicAuthService;
